import { VariantProps } from 'class-variance-authority'
import { InfoIcon } from 'lucide-react'

import { documentErrorLabel, documentStatusLabel } from '@/const/label'

import { Badge } from '@/components/lemmala-design-system/badge/badge'
import { DocumentStatusIcon } from '@/components/shared/document-status-badge/document-status-icon'
import { documentStatusVariant } from '@/components/shared/document-status-badge/variants'

type BaseDocumentStatusBadgeProps = VariantProps<typeof documentStatusVariant>

export const BaseDocumentStatusBadge = ({
  status,
  error,
  hoverable,
  highlighted,
}: BaseDocumentStatusBadgeProps) => {
  if (!status) return null
  return (
    <Badge
      variant='outline'
      className={documentStatusVariant({
        status,
        error,
        hoverable,
        highlighted,
      })}
    >
      <DocumentStatusIcon status={status} error={error} />
      {error ? documentErrorLabel[error] : documentStatusLabel[status]}
      {hoverable && <InfoIcon size={12.5} strokeWidth={1.5} />}
    </Badge>
  )
}
